"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
const react_1 = require("react");
/** Hook to listen to component size change
 * @param object of: {
 *  callback: ResizeObserverCallback
 *  ref: RefObject<any>,
 * }
 */
const useResizeObserver = ({ callback, ref, elem, }) => {
    (0, react_1.useEffect)(() => {
        const observer = new ResizeObserver(callback);
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            observer.observe(ref.current);
        }
        if (elem) {
            observer.observe(elem);
        }
        return () => {
            observer.disconnect();
        };
    }, [ref, elem, callback]);
};
exports.useResizeObserver = useResizeObserver;
//# sourceMappingURL=useResizeObserver.js.map